<app-banner [banner]="banner"></app-banner>
<div></div>
<div class="m-auto flex flex-col justify-center flex-1">
  <app-logo class="mx-auto mb-8" [height]="logoHeight + 'px'"></app-logo>
  <div data-test='landing-title' class="text-center mb-12" [innerHTML]="'landing.presentation' | translate"></div>
</div>
<button appRipple id="next" data-test="next-btn" class="next-button ml-auto" (debounceClick)="onClick()">
  <mat-icon>arrow_forward_ios</mat-icon>
</button>
